import {ClsCatalogosExpIns2} from './cls-catalogo-general';
import {ClsCalculoMatriz} from './cls-calculo';

export class ClsMatriz {
  IdCodigoMatriz?: bigint;
  IdCodigoMatrizS?: string;
  CodigoMatriz?: string;
  DescripcionMatriz?: string;
  DescripcionLarga?: string;
  TipoInsumoMatriz?: number;
  UnidadMatriz?: string;
  CodigoAuxiliar?: string;
  DescripcionAuxiliar?: string;
  CostoMoneda1Matriz?: number;
  CostoMoneda2Matriz?: number;
  JsonMatriz?: string;
  PendienteAnalizar?: boolean;
  ObservacionPendiente?: string;
  UrlContenido?: string;
  Insumos: any[]; // los obj que debe recibir son: ClsDetalleMatrizInsumos[] | ClsCalculoMatriz[];
}

export class ClsDetalleMatrizInsumos {
  Control: number;
  IdCatalogo: bigint;
  IdCatalogoS?: string;
  IdCodigoInsumo?: bigint;
  Renglon: number;
  Codigo: string;
  Descripcion: string;
  DescripcionLarga: string;
  DescripcionTipoInsumo?: string;
  TipoInsumo: number;
  Unidad: string;
  Volumen: number;
  Dividir: boolean;
  TipoOperacion: string;
  Nivel: number;
  EsPorcentaje: number;
  EsCostoHorario: boolean;
  CostoMoneda1: number;
  CostoMoneda2: number;
  ImporteMoneda1: number;
  ImporteMoneda2: number;
  Expresion: string;
}

export class ClsConceptosInsumos {
  IdCatalogo: bigint;
  Codigo: string;
  Descripcion: string;
  DescripcionLarga: string;
  TipoInsumo: number;
  Unidad: string;
  Cantidad?: number;
  CostoMoneda1: number;
  CostoMoneda2: number;
  Familia?: string;
  EsCostoHorario: boolean;
  TipoPorcentaje: number;
  EsPorcentaje: boolean;
}

export class ClsGuardarMatriz {
  IdMatriz: bigint;
  IdCodigoMatriz: bigint;
  PendienteAnalizar: boolean;
  ObservacionPendiente: string;
  DescripcionLarga: string;
  CostoMoneda1: number;
  CostoMoneda2: number;
  MatrizOriginal: ClsGuardarMatrizDetalle[];
  MatrizNueva: ClsGuardarMatrizDetalle[];
}

export class ClsGuardarMatrizDetalle {
  Control: number;
  IdCatalogo: bigint;
  Renglon: number;
  Volumen: number;
  Dividir: boolean;
  CostoMoneda1: number;
  CostoMoneda2: number;
  Expresion: string;
  Catalogo: ClsCatalogosExpIns2;
}

export class ClsMatrizCalculo {
  MatrizDetalle: ClsMatrizCalculoDetalle[];
}

export class ClsMatrizCalculoDetalle {
  IdInsumo: bigint; // idcatalogo insumo
  // Control: number;
  // Renglon: number;
  Volumen: number;
  // Dividir: boolean;
  // Expresion: string;
}
